import axios from "axios";
import {
  ALL_USER_DETAILS_FAIL,
  ALL_USER_DETAILS_REQUEST,
  ALL_USER_DETAILS_SUCCESS,
  USER_ADD_FAIL,
  USER_ADD_REQUEST,
  USER_ADD_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_CHANGE_PASS_FAIL,
  USER_CHANGE_PASS_REQUEST,
  ADMIN_USERS_REQUEST,
  ADMIN_USERS_SUCCESS,
  ADMIN_USERS_FAIL,
  ADMIN_USER_UPDATE_REQUEST,
  ADMIN_USER_UPDATE_SUCCESS,
  ADMIN_USER_UPDATE_FAIL,
  ADMIN_USER_DELETE_REQUEST,
  ADMIN_USER_DELETE_SUCCESS,
  ADMIN_USER_DELETE_FAIL,
  ADMIN_LABS_REQUEST,
  ADMIN_LABS_SUCCESS,
  ADMIN_LABS_FAIL,
  ADMIN_LAB_CREATE_REQUEST,
  ADMIN_LAB_CREATE_SUCCESS,
  ADMIN_LAB_CREATE_FAIL,
  ADMIN_LAB_UPDATE_REQUEST,
  ADMIN_LAB_UPDATE_SUCCESS,
  ADMIN_LAB_UPDATE_FAIL,
  ADMIN_LAB_DELETE_REQUEST,
  ADMIN_LAB_DELETE_SUCCESS,
  ADMIN_LAB_DELETE_FAIL,
} from "../constants/userConstant";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "/api/v1/users/login",
      { email, password },
      config
    );

    if (!data || typeof data === "string" || !data.token) {
      throw new Error("Invalid response received from the server. Check backend connections.");
    }

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });

    sessionStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message || "Unable to login, please try again later",
    });
  }
};

export const logout = () => (dispatch) => {
  sessionStorage.removeItem("userInfo");
  dispatch({ type: USER_LOGOUT });
  document.location.href = "/login";
};

export const register = (name, email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_REGISTER_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "/api/users",
      { name, email, password },
      config
    );

    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: data,
    });

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });

    sessionStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addUsers = (name, email, password) => async (dispatch,getState) => {
  try {
    dispatch({
      type: USER_ADD_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(
      "/api/v1/users/adduser",
      { name, email, password },
      config
    );

    dispatch({
      type: USER_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_ADD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUserDetails = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(`/api/v1/users/user`, config);
    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


//get all user details
export const getAllUserDetails = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: ALL_USER_DETAILS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(`/api/v1/users/all`, config);

    dispatch({
      type: ALL_USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ALL_USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const updateUserProfile = (userData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_UPDATE_PROFILE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(`/api/v1/users/update`, userData, config);
    dispatch({
      type: USER_UPDATE_PROFILE_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: USER_UPDATE_PROFILE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const changeUserPassword = (userData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_CHANGE_PASS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    await axios.post(`/api/v1/users/resetPass`, userData, config);
    sessionStorage.removeItem("userInfo");
    dispatch({ type: USER_LOGOUT });
    document.location.href = "/login";

  } catch (error) {
    dispatch({
      type: USER_CHANGE_PASS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ====== ADMIN ACTIONS ======

// Get all users (admin/lab)
export const adminGetAllUsers = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USERS_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(`/api/v1/admin/users`, config);
    dispatch({ type: ADMIN_USERS_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMIN_USERS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create user (admin/lab)
export const adminCreateUser = (userData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USER_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(`/api/v1/admin/users/create`, userData, config);
    dispatch({ type: ADMIN_USER_UPDATE_SUCCESS, payload: data });
    // Refresh user list
    dispatch(adminGetAllUsers());
  } catch (error) {
    dispatch({
      type: ADMIN_USER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update user (admin)
export const adminUpdateUser = (userData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USER_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(`/api/v1/admin/users/update`, userData, config);
    dispatch({ type: ADMIN_USER_UPDATE_SUCCESS, payload: data });
    dispatch(adminGetAllUsers());
  } catch (error) {
    dispatch({
      type: ADMIN_USER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Soft delete user (admin)
export const adminDeleteUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USER_DELETE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.delete(`/api/v1/admin/users/delete/${id}`, config);
    dispatch({ type: ADMIN_USER_DELETE_SUCCESS, payload: data });
    dispatch(adminGetAllUsers());
  } catch (error) {
    dispatch({
      type: ADMIN_USER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Reactivate user (admin)
export const adminReactivateUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USER_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(`/api/v1/admin/users/reactivate/${id}`, {}, config);
    dispatch({ type: ADMIN_USER_UPDATE_SUCCESS, payload: data });
    dispatch(adminGetAllUsers());
  } catch (error) {
    dispatch({
      type: ADMIN_USER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Admin reset password for any user
export const adminResetPassword = (userId, newPassword) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_USER_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(`/api/v1/admin/users/resetPassword`, { userId, newPassword }, config);
    dispatch({ type: ADMIN_USER_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ADMIN_USER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ====== LAB ACTIONS ======

// Get all labs (admin)
export const adminGetAllLabs = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_LABS_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.get(`/api/v1/admin/labs`, config);
    dispatch({ type: ADMIN_LABS_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMIN_LABS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create lab (admin)
export const adminCreateLab = (labData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_LAB_CREATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(`/api/v1/admin/labs/create`, labData, config);
    dispatch({ type: ADMIN_LAB_CREATE_SUCCESS, payload: data });
    dispatch(adminGetAllLabs());
  } catch (error) {
    dispatch({
      type: ADMIN_LAB_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update lab (admin)
export const adminUpdateLab = (labData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_LAB_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(`/api/v1/admin/labs/update`, labData, config);
    dispatch({ type: ADMIN_LAB_UPDATE_SUCCESS, payload: data });
    dispatch(adminGetAllLabs());
  } catch (error) {
    dispatch({
      type: ADMIN_LAB_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Soft delete lab (admin)
export const adminDeleteLab = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_LAB_DELETE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.delete(`/api/v1/admin/labs/delete/${id}`, config);
    dispatch({ type: ADMIN_LAB_DELETE_SUCCESS, payload: data });
    dispatch(adminGetAllLabs());
  } catch (error) {
    dispatch({
      type: ADMIN_LAB_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Reactivate lab (admin)
export const adminReactivateLab = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADMIN_LAB_UPDATE_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(`/api/v1/admin/labs/reactivate/${id}`, {}, config);
    dispatch({ type: ADMIN_LAB_UPDATE_SUCCESS, payload: data });
    dispatch(adminGetAllLabs());
  } catch (error) {
    dispatch({
      type: ADMIN_LAB_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};